import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonIssueModule } from '@monsido/modules/issue/issue.module';
import { IconsModule, LayoutModule, MonTableSortModule, TableModule } from '@monsido/angular-shared-components';
import { QaMisspellingIssueComponent } from './qa-misspelling-issue/qa-misspelling-issue.component';
import { LanguagesModule } from 'app/modules/languages-ng2/languages.module';

import { QaBrokenIssueComponent } from './qa-broken-issue/qa-broken-issue.component';
import { SharedModule } from '@monsido/ng2/shared/shared.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';

@NgModule({
    imports: [
        CommonModule,
        MonIssueModule,
        TableModule,
        TranslateModule,
        IconsModule,
        NgbTooltipMfeModule,
        LayoutModule,
        MonTableSortModule,
        LanguagesModule,
        NgbTooltipMfeModule,
        SharedModule,
    ],
    exports: [],
    declarations: [
        QaBrokenIssueComponent,
        QaMisspellingIssueComponent,
    ],
    providers: [],
})
export class QaComponentsModule {}
